virtual function void write({{#findIn superclasses "subscribedTransaction"}}{{ type }}{{/findIn}} t);
{{#unless isFirstLevelComponent}}
  super.write(t);
{{/unless}}
endfunction
